import { lazy, Component } from 'solid-js';

let Login: Component;
if (['android', 'android_production'].includes(import.meta.env.MODE)) {
  Login = lazy(() => import('./LoginAndroid'));
} else {
  Login = lazy(() => import('./Login'));
}

let RegisterUser: Component;
if (['android', 'android_production'].includes(import.meta.env.MODE)) {
  RegisterUser = lazy(() => import('./RegisterAndroid'));
} else {
  RegisterUser = lazy(() => import('./RegisterUser'));
}

let Recover: Component;
if (['android', 'android_production'].includes(import.meta.env.MODE)) {
  Recover = lazy(() => import('./RecoverAndroid'));
} else {
  Recover = lazy(() => import('./Recover'));
}

let Verification: Component;
if (['android', 'android_production'].includes(import.meta.env.MODE)) {
  Verification = lazy(() => import('./VerificationAndroid'));
} else {
  Verification = lazy(() => import('./Verification'));
}

let Settings: Component;
if (['android', 'android_production'].includes(import.meta.env.MODE)) {
  Settings = lazy(() => import('./SettingsAndroid'));
} else {
  Settings = lazy(() => import('./Settings'));
}

export { RegisterUser, Recover, Login, Settings, Verification };
export { default as Error } from './Error';
